import { useMutation } from '@apollo/client/react';

import { AppCreateDocument } from 'src/graphql/actions/apps/appCreate.mutation';
import { AppCriticalityEnum } from 'src/graphql/schema';
import { ClientError } from 'src/utils/errors';
import { refetchApps } from 'src/containers/Applications/List/api';

import type { IOwnApplicationForm } from './ownApplicationSchema';

import { useAppLogoUpload } from './useAppLogoUpload';

export const useCreateOwnApp = () => {
  const [createApp] = useMutation(AppCreateDocument);
  const uploadAppLogo = useAppLogoUpload();

  return async (data: IOwnApplicationForm) => {
    const logo = data.logo instanceof File ? await uploadAppLogo(data.logo) : undefined;

    const { data: created } = await createApp({
      variables: {
        appParams: {
          ...data,
          logo,
          criticality: data.criticality as AppCriticalityEnum,
        },
      },
    });

    if (!created?.appCreate?.success) throw new ClientError(created?.appCreate?.errors?.[0]);

    const appId = created.appCreate.app?.id;
    if (!appId) throw new ClientError();

    refetchApps();

    return appId;
  };
};
